export const ComponentType: ComponentType = {
  error: "error",
  warning: "warning",
  success: "success",
  info: "info",
};

export interface ComponentType {
  info: string;
  success: string;
  warning: string;
  error: string;
}

export interface IAxToastOptions {
  title?: string;
  bodyContent?: string | HTMLElement;
  className?: string;
  componentType?: string | undefined;
  id?: string;
  zIndex?: number;
  autoDismissAfter?: number | 0;
}

export type IAxToastOptionsSubjectType = IAxToastOptions | null;

export type AxToastManagerCallbackType = (
  option: IAxToastOptionsSubjectType
) => void;
